<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader :page-name="pageName" parent-page-name="Videos" parent-page-url="/videos" />
      <add-edit-form
        v-if="model"
        returnUrl="/videos"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import Video from '@/models/Video'
/* eslint-disable no-undef */
export default {
  name: 'AddVideo',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit Video' : 'Add Video'
    }
  },
  data () {
    return {
      API_BASE_URL: 'video',
      model: null,
      fields: [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'MP4 Format', key: 'MP4', type: 'format' }
      ]
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new Video()
    }
  },
  methods: {
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new Video(result.video)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Videos/AddEdit.vue